/**
 * @description 中插视频支持
 * @author samuelsli
 */
import { loadScript } from '@iv/shared/src/load';
import events from 'events';

// 创建插播H5的DOM
function createDom(containerId: string) {
  const template = `
    <div id="clip_container" style="position: absolute;top: 0;bottom:0;right:0;left:0;">
      <div id="light_player_wrapper" style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;background:black;z-index: 999;">
        
        <div id="clip_h5_player" style="position:absolute;width:100%;height:100%;top:50%;left:50%;transform: translate(-50%, -50%);"></div>

        <div id="clip_loading" style="display:none;position: absolute;top: 0;bottom: 0;left: 0;right: 0;background:black;display:flex;align-items:center;justify-content:center">
          <style>
            @-webkit-keyframes loading{
              from{
                background-position: 0 0;
              }
              to{
                background-position: 0 -300px;
              }
            }
          </style>
          <i style="
            display: block;
            width: 27px;
            height: 10px;
            background: url(http://imgcache.gtimg.cn/tencentvideo_v1/vstyle/mobile/v2/style/img/common/loading.png) 0 0 no-repeat;
            -webkit-background-size: 27px 300px;
            background-size: 27px 300px;
            -webkit-animation: loading 1s steps(30) infinite;
          "></i>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display:none">
          <symbol id="svg_close"><g><g transform="translate(-1320.000000, -115.000000)"><g transform="translate(1318.000000, 114.000000)"><g transform="translate(0.500000, -0.000000)"><path style="stroke:#FFFFFF;stroke-opacity:0.1;" d="M8,1.5h47c3.3,0,6,2.7,6,6v47c0,3.3-2.7,6-6,6H8c-3.3,0-6-2.7-6-6v-47C2,4.2,4.7,1.5,8,1.5z"></path><g transform="translate(31.616117, 31.116117) rotate(-45.000000) translate(-31.616117, -31.116117) translate(9.616117, 9.116117)"><path style="fill:#FFFFFF;" d="M1.2,20.8h41.6c0.7,0,1.2,0.5,1.2,1.2v0c0,0.7-0.5,1.2-1.2,1.2H1.2C0.5,23.2,0,22.7,0,22
            l0,0C0,21.3,0.5,20.8,1.2,20.8z"></path><path style="fill:#FFFFFF;" d="M23.2,1.2v41.6c0,0.7-0.5,1.2-1.2,1.2l0,0c-0.7,0-1.2-0.5-1.2-1.2V1.2
            C20.8,0.5,21.3,0,22,0l0,0C22.7,0,23.2,0.5,23.2,1.2z"></path></g></g></g></g></g></symbol>
        </svg>
        <a id="light_player_close" href="javascript:;" style="z-index: 999;height: 20px;width: 20px;position: absolute;right: 5%;top: 5%;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60"><use xlink:href="#svg_close"></use></svg></a>

      </div>
    </div>
  `;
  if (!document.getElementById('light_player_wrapper')) {
    const div = document.createElement('div');
    div.innerHTML = template.trim();
    const html = div.childNodes[0];

    document.getElementById(containerId).appendChild(html);
  }

  return {
    clipContainer: document.getElementById('clip_container'),
    videoContainer: document.getElementById('light_player_wrapper'),
    video: document.getElementById('clip_h5_player'),
    closeBtn: document.getElementById('light_player_close'),
    clipLoading: document.getElementById('clip_loading'),
  };
}

export default class VideoClip {
  private static instance: VideoClip;
  public static getInstance(containerId: string) {
    if (!VideoClip.instance) {
      VideoClip.instance = new VideoClip(containerId);
    }

    return VideoClip.instance;
  }

  private msg: events.EventEmitter;
  private clipContainer: HTMLElement;
  private videoContainer: HTMLElement;
  private video: HTMLElement;
  private closeBtn: HTMLElement;
  private clipLoading: HTMLElement;
  private toPlay: Boolean; // 标记视频是否要播放

  private player: any;

  protected constructor(containerId: string) {
    const { clipContainer, videoContainer, video, closeBtn, clipLoading } = createDom(containerId);
    this.clipContainer = clipContainer;
    this.videoContainer = videoContainer;
    this.video = video;
    this.closeBtn = closeBtn;
    this.clipLoading = clipLoading;

    this.msg = new events.EventEmitter();

    // 点击隐藏浮层
    this.closeBtn.addEventListener('click', () => {
      this.hideClip();
    });
  }

  public on(eventName: string, callback: any) {
    this.msg.on(eventName, callback);
  }

  public once(eventName: string, callback: any) {
    this.msg.once(eventName, callback);
  }

  public async showClip(param: {
    vid: string,
    x: number,
    y: number,
    width: number,
    height: number,
    hideCloseBtn?: boolean,
  }) {
    this.toPlay = true;

    const { vid, x, y, width, height, hideCloseBtn } = param;

    this.videoContainer.style.width = `${width}%`;
    this.videoContainer.style.height = `${height}%`;
    this.videoContainer.style.left = `${x}%`;
    this.videoContainer.style.top = `${y}%`;

    this.clipContainer.style.display = 'block';
    this.closeBtn.style.display = hideCloseBtn ? 'none' : 'block';

    // 展示loading
    this.clipLoading.style.display = 'flex';

    if (!this.player) {
      await this.initPlayer();
    }

    this.player.play(vid);
  }

  public hideClip() {
    this.toPlay = false;
    this.player.pause();
    this.clipContainer.style.display = 'none';

    this.msg.emit('hideClip');
  }

  private updatePaddingSize(videoRatio: number) {
    // 容器宽高比
    const wrapperRatio = this.videoContainer.clientWidth / this.videoContainer.clientHeight;
    if (videoRatio > wrapperRatio) {
      this.video.style.width = '100%';
      this.video.style.height = `${(this.videoContainer.clientWidth) / (this.videoContainer.clientHeight * videoRatio) * 100}%`;
    } else {
      this.video.style.width = `${(this.videoContainer.clientHeight * videoRatio) / (this.videoContainer.clientWidth) * 100}%`;
      this.video.style.height = '100%';
    }
  }

  private async initPlayer() {
    if (!window.Txiplayer) {
      await loadScript('//vm.gtimg.cn/tencentvideo/script/txi/js/player.js?t=1561534056870');
    }
    this.player = new window.Txiplayer({
      container: '#clip_h5_player',
    });

    this.player.on('segStartPlay', () => {
      const size = this.player.getVideoSize();
      const streamRatio = size.width / size.height;
      this.updatePaddingSize(streamRatio);

      // 隐藏loading
      this.clipLoading.style.display = 'none';
    });

    // 自动播放和用户在未初始化完成就退出时也要暂停播放
    this.player.on('timeupdate', () => {
      if (!this.toPlay) {
        this.player.pause();
      }
    });

    this.player.on('statechange', (data: { new: any }) => {
      if (data.new === 'end') {
        this.hideClip();
      }
    });

    this.player.on('error', () => {
      this.hideClip();
    });
  }
}
